// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1tXmJ","name":"styles_name__26Zcd","phone":"styles_phone__2QNAm"};